import { useEffect } from 'preact/hooks';
import { BADGE_CATALOG, earnedBadges } from '../state/badges-store.js';

type Props = { onClose: () => void };

function formatDate(ts: number): string {
  const d = new Date(ts);
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

export function BadgeInventory({ onClose }: Props) {
  const earned = earnedBadges.value;
  const earnedCount = BADGE_CATALOG.filter((b) => !!earned[b.id]).length;
  const total = BADGE_CATALOG.length;
  const pct = total > 0 ? (earnedCount / total) * 100 : 0;

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const onScrim = (e: MouseEvent) => {
    if ((e.target as HTMLElement) === (e.currentTarget as HTMLElement)) onClose();
  };

  return (
    <div class="modal-scrim" onClick={onScrim}>
      <div class="modal-sheet">
        <div class="modal-sheet-grabber" />
        <div class="modal-sheet-header">
          <span class="modal-sheet-title">Your Achievements</span>
          <button type="button" class="modal-sheet-close" onClick={onClose} aria-label="Close">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
        <div class="modal-sheet-body">
          <div class="badge-progress-bar-wrap">
            <span class="badge-progress-label">{earnedCount} of {total} badges earned</span>
            <div class="badge-progress-track" role="progressbar" aria-valuenow={earnedCount} aria-valuemin={0} aria-valuemax={total}>
              <div class="badge-progress-fill" style={{ width: `${pct}%` }} />
            </div>
          </div>

          <div class="badge-grid">
            {BADGE_CATALOG.map((b) => {
              const entry = earned[b.id];
              const isEarned = !!entry;
              return (
                <div class={`badge-card${isEarned ? ' is-earned' : ' is-locked'}`} key={b.id}>
                  <span class="badge-card-icon">{b.icon}</span>
                  <span class="badge-card-label">{b.label}</span>
                  {isEarned
                    ? <span class="badge-card-date">Earned {formatDate(entry.earnedAt)}</span>
                    : <span class="badge-card-desc">{b.description}</span>
                  }
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
